import { ILoginResponse } from '@app/api/interfaces/auth.interface';

export const loginMockData: ILoginResponse = {
  status: 'SUCCESS',
  message: 'sss',
  data: 'sss',
};
